import {
  GET_USERS_REQUEST,
  GET_USERS_SUCCESS,
  GET_USERS_FAILURE,
  GET_USERS_BY_COMPANY_REQUEST,
  GET_USERS_BY_COMPANY_SUCCESS,
  GET_USERS_BY_COMPANY_FAILURE,
} from '../../constants/action-types';

const getInitialState = () => {
  return {
    isLoading: false,
    data: [],
  };
};

const initialState = getInitialState();

const users = (state = initialState, action) => {
  const types = {
    [GET_USERS_REQUEST]: () => ({
      ...state,
      isLoading: true,
    }),
    [GET_USERS_SUCCESS]: () => ({
      ...state,
      isLoading: false,
      data: action.response || [],
    }),
    [GET_USERS_FAILURE]: () => ({
      ...state,
      isLoading: false,
    }),
    [GET_USERS_BY_COMPANY_REQUEST]: () => ({
      ...state,
      isLoading: true,
    }),
    [GET_USERS_BY_COMPANY_SUCCESS]: () => ({
      ...state,
      isLoading: false,
      data: action.response || [],
    }),
    [GET_USERS_BY_COMPANY_FAILURE]: () => ({
      ...state,
      isLoading: false,
    }),
  };

  if (!types[action.type]) {
    return state;
  }

  return types[action.type]();
};

export default users;
